export const myopWebcomponentConsts = {
    webcomponent_message_key: 'myop_webcomponent_message'
}
